import actions from '@/shared/store-modules/calendar/actions';
import getters from '@/shared/store-modules/calendar/getters';
import mutations from '@/shared/store-modules/calendar/mutations';
import { RESERVATION_STATUS } from '@/Calendar/const';
const state = () => ({
    RESERVATION_STATUS,
    WEEKDAYS: [1, 2, 3, 4, 5, 6, 7],
    errorSpaceBookings: '',
    currentDay: '',
    currentWeekNumber: '',
    selectedDay: ''
});
export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};
